import { combineTokens, makeSelectors } from '@utils/css';

const tokens = combineTokens("--iguide--task", {
  contextWidth: "100%",
  inputsWidth: "100%"
});
const modifiers = makeSelectors({
  hasContextAndTask: "_uxsh11gcqyp",
  inputsLongerThanViewport: "_uxsi1du5pcl",
  contextLongerThanViewport: "_uxsc1jli7as"
});
const wrapper = "_uxsw1hj4srw";
const contentWrapper = "_uxscxadlfy";
const contextWrapper = "_uxsc1clip9g";
const contextContentWrapper = "_uxsc3x9tr5";
const inputsWrapper = "_uxsi1eqo3ss";
const inputsContentWrapper = "_uxsirw4g2h";

export { contentWrapper, contextContentWrapper, contextWrapper, inputsContentWrapper, inputsWrapper, modifiers, tokens, wrapper };
import "./molecule.task.style.linaria.module.css";
//# sourceMappingURL=molecule.task.style.js.map
